import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Attach bearer token from localStorage as a backup (cross-site cookie fallback)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("oscopge_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401 mid-session, clear stale token and redirect to login.
// /auth/me 401 (initial check) is intentionally ignored.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const url = error.config?.url || "";
    if (status === 401 && !url.includes("/auth/me") && !url.includes("/auth/login")) {
      // Token expired mid-session
      localStorage.removeItem("oscopge_token");
      // Redirection uniquement depuis l'espace protégé : les pages publiques (/, /register, /verify) restent accessibles.
      if (typeof window !== "undefined" && window.location.pathname.startsWith("/app")) {
        window.location.replace("/login");
      }
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
